import React from 'react';
import {
  Paper,
  Typography,
  List,
  ListItem,
  ListItemText,
  Chip
} from '@mui/material';
import { AirplanemodeActive } from '@mui/icons-material';

const AircraftUtilizationCard = ({ aircraftUtilization }) => {
  if (aircraftUtilization.length === 0) {
    return null;
  }

  return (
    <Paper sx={{ p: 2, mb: 3 }}>
      <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <AirplanemodeActive color="info" />
        Aircraft Utilization
      </Typography>
      <List>
        {aircraftUtilization.slice(0, 10).map((ac, idx) => (
          <ListItem key={idx} divider>
            <ListItemText
              primary={`${ac.registration} - ${ac.manufacturer} ${ac.model}`}
              secondary={`Flight Hours: ${ac.flightHours || 0} • Status: ${ac.status}`}
            />
            <Chip
              label={`${ac.flightHours || 0} hrs`}
              size="small"
              color={ac.status === 'AVAILABLE' ? 'success' : 'default'}
            />
          </ListItem>
        ))}
      </List>
    </Paper>
  );
};

export default AircraftUtilizationCard;

